
import React from 'react';
import { motion } from 'framer-motion';
import StorePreview from '../components/StorePreview';
import DonationSection from '../components/DonationSection';

const StoreDonate = () => {
  return (
    <div className="min-h-screen">
      <div className="min-h-screen bg-gradient-to-b from-blue-900 to-black py-24">
        <div className="max-w-6xl mx-auto px-4">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            className="text-center mb-12"
          >
            <h1 className="text-5xl font-bold text-white mb-6">Support Our Mission</h1>
            <p className="text-xl text-blue-200 max-w-2xl mx-auto">
              Help us protect winter sports for future generations. Your contribution makes a difference.
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
            className="max-w-3xl mx-auto"
          >
            <div className="aspect-[4/3] w-full bg-white/10 backdrop-blur-sm rounded-lg overflow-hidden">
              <iframe
                src="https://www.gofundme.com/f/preserve-winter-sports-with-the-powder-project/widget/large/"
                className="w-full h-full"
                frameBorder="0"
                scrolling="no"
                title="Support The Powder Project"
              ></iframe>
            </div>
          </motion.div>

          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ delay: 0.4 }}
            className="mt-12 text-center text-blue-200"
          >
            <p>
              Can't donate? Share our campaign with your network to help spread the word!
            </p>
          </motion.div>
        </div>
      </div>
    </div>
  );
};

export default StoreDonate;
